import { Injectable } from '@angular/core';
import { Http, Response, Headers,RequestOptions } from '@angular/http';

@Injectable()

export class HydrogenAppConfigService {

    config: any;

    constructor(private http: Http) {
    }

    loadConfig() {
        return new Promise((resolve, reject) => {
            //YH 1/19/2017 Fix for Firefox. Spell out to pesky FF that it should accept a json
            let headers = new Headers({ 'Accept': 'application/json' });
            let options = new RequestOptions({ headers: headers });
            this.http.get('app/app.settings.json',options)
                .subscribe((data) => {
                    this.config = data.json();
                    resolve();
                });
        });
    }
};


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/host.config.service.ts